import React from "react";

export const InfoSolid = ({
  size = "24",
  color = "currentColor",
}: {
  size?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.745 9.41566 20.7162 6.93859 18.8888 5.11118C17.0614 3.28378 14.5843 2.25496 12 2.25ZM11.8125 6.75C12.035 6.75 12.2525 6.81598 12.4375 6.9396C12.6225 7.06321 12.7667 7.23891 12.8519 7.44448C12.937 7.65005 12.9593 7.87625 12.9159 8.09448C12.8725 8.31271 12.7653 8.51316 12.608 8.6705C12.4507 8.82783 12.2502 8.93498 12.032 8.97838C11.8138 9.02179 11.5876 8.99951 11.382 8.91436C11.1764 8.82922 11.0007 8.68502 10.8771 8.50002C10.7535 8.31501 10.6875 8.0975 10.6875 7.875C10.6875 7.57663 10.806 7.29048 11.017 7.0795C11.228 6.86853 11.5141 6.75 11.8125 6.75ZM12.75 17.25H12C11.8011 17.25 11.6103 17.171 11.4697 17.0303C11.329 16.8897 11.25 16.6989 11.25 16.5V12C11.0511 12 10.8603 11.921 10.7197 11.7803C10.579 11.6397 10.5 11.4489 10.5 11.25C10.5 11.0511 10.579 10.8603 10.7197 10.7197C10.8603 10.579 11.0511 10.5 11.25 10.5H12C12.1989 10.5 12.3897 10.579 12.5303 10.7197C12.671 10.8603 12.75 11.0511 12.75 11.25V15.75C12.9489 15.75 13.1397 15.829 13.2803 15.9697C13.421 16.1103 13.5 16.3011 13.5 16.5C13.5 16.6989 13.421 16.8897 13.2803 17.0303C13.1397 17.171 12.9489 17.25 12.75 17.25Z"
        fill={color}
      />
    </svg>
  );
};
